export default __webpack_public_path__ + "static/media/nav_img_15.91f6303d.jpg";